import { VueConstructor } from 'vue';

import CellFormatter from './CellFormatter.vue';
import ExpansionCard from './ExpansionCard.vue';
import ErrorPage from './ErrorPage.vue';
import FileInput from './FileInput.vue';
import CustomFormBuilder from './CustomFormBuilder.vue';
import CollectionTypeForm from './CollectionTypeForm.vue';
import InfoCard from './InfoCard.vue';
import PageCard from './PageCard.vue';
import PopUp from './PopUp.vue';
import TextTooltipFormatter from './TextTooltipFormatter.vue';
import SelectField from '@/components/globals/SelectField.vue';
import CustomPeriodField from '@/components/globals/CustomPeriodField.vue';

interface Components {
	[name: string]: VueConstructor;
}

const components: Components = {
	CellFormatter,
	ErrorPage,
	ExpansionCard,
	FileInput,
	CustomFormBuilder,
	CollectionTypeForm,
	CustomPeriodField,
	InfoCard,
	PageCard,
	PopUp,
	SelectField,
	TextTooltipFormatter
};

/** Globally register all global components */
function registerComponents(Vue: VueConstructor) {
	Object
		.keys(components)
		.forEach((name: string) => {
			Vue.component(name, components[name]);
		});
}

export default registerComponents;
